const link  = 'https://microgoogol.herokuapp.com';
// const link = 'http://localhost:8080';
export default link;
